// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cm56","question":"styles_question__3eG9C","description":"styles_description__1hzcg"};